import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_2 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "text-start p-sm" }
const _hoisted_4 = { class: "text-start p-sm" }
const _hoisted_5 = { class: "text-start p-sm" }
const _hoisted_6 = { class: "text-start p-sm" }
const _hoisted_7 = { class: "p-sm" }
const _hoisted_8 = { class: "p-sm" }
const _hoisted_9 = { class: "p-sm" }
const _hoisted_10 = { class: "p-sm" }
const _hoisted_11 = { class: "text-end p-sm" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  colspan: "5",
  class: "text-center py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__lg",
    title: _ctx.helper.trans('labels.reattach_counterparty'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.requisites')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.holderName')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.method')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRequisites, (req, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: ""
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(req.requisites), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(req.currency), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(req.holderName), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.helper.trans('pay_methods.' + req.method)), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.selectRequisite(req.id)),
                        class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('labels.select')), 9, _hoisted_12)
                    ])
                  ]))
                }), 128)),
                (_ctx.availableRequisites.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.no_available_requisites')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}